import { z } from "zod";
import { NumericStringOrNumber } from "./primitives";

// TODO: Copied (partially)from firebase/lmt/src/common/types. Replace the file there with imports from this file and move tests if any.

/*
 * EVERYTHING IN THIS FILE IS DEPRECATED AND SHOULD NOT BE USED IN ANY NEW FEATURES
 * - Chat uses CatalogArticleItem for showing old Storyblok articles that exists in Firestore
 * - Catalog article previews still use ArticlePreview, needs FullArticle.tsx to be refactored
 */

const AssetResponse = z
    .object({
        filename: z.string(),
        id: z.number().nullable(),
    })
    .nullable();

export type AssetResponse = z.infer<typeof AssetResponse>;

export const ArticleContentPlace = z.object({
    lat: NumericStringOrNumber,
    lon: NumericStringOrNumber,
    uid: z.string().optional().nullable(),
    name: z.string(),
    address: z.string(),
    country: z.string().optional(),
    component: z.literal("googlePlace"),
    googlePlaceId: z.string(),
});

export const ArticleCallToActionEnum = z.enum([
    "request_more_info",
    "ask_lifestyle_manager",
    "place_request",
]);

export type ArticleCallToActionEnum = z.infer<typeof ArticleCallToActionEnum>;

export const ArticleCallToAction = z
    .string()
    .transform((value) => {
        if (value === "") {
            return "place_request";
        }
        return value;
    })
    .refine((value) => ArticleCallToActionEnum.options.includes(value as never), {
        error: "Invalid enum value",
    });

export type ArticleContentPlace = z.infer<typeof ArticleContentPlace>;

export const ArticleContent = z.object({
    catalogItemId: z.string().nullable().optional(),
    title: z.string(),
    content: z.string(),
    component: z.literal("article"),
    coverImage: AssetResponse,
    additionalImages: z.array(AssetResponse),
    place: z.array(ArticleContentPlace).optional().nullable(),
    insight: z.string().optional().nullable(),
    callToAction: ArticleCallToAction.optional().nullable(),
});

export type ArticleContent = z.infer<typeof ArticleContent>;

export const CatalogArticleItem = z.object({
    uuid: z.string(),
    fullSlug: z.string(),
    createdAt: z.string().optional(),
    tagList: z.array(z.string()),
    slug: z.string(),
    publishedAt: z.string().optional(),
    firstPublishedAt: z.string().optional(),
    content: ArticleContent,
});

export type CatalogArticleItem = z.infer<typeof CatalogArticleItem>;
